/**
 * Service/ResourcePool Controller
 *
 * Displays information about resource pool orders
 */

// the constructor for this object
function ServiceResourcePoolController() { }

// the object
ServiceResourcePoolController.prototype = {
    constructor: ServiceResourcePoolController,

    // the base order id
    baseOrderId: false,
    
    // store the memory chart object here
    memoryChart: false,
    
    // store the compute chart object here
    computeChart: false,
    
    // the number of charts we'll create for use later in the controller
    maxCharts: 30,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // set up the pagination
        this._setupPagination();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Resource Pool Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
        
        // get and populate generic order information
        this._getOrder();
        
        // get usage-based order info
        this._getResourcePoolOrder();
        
        // get and populate the vms
        this._getVms();
        
        // get the resource pool stats
        this._getResourcePoolStats();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Resource Pool Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#vms-pagination';
        pagination.contentSelector = '#vms-table';
        pagination.searchSelector = '#vms-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.ServiceResourcePoolController._getVms;
        PortalMain.ServiceResourcePoolController.pagination = pagination;
    },
    
    // set up the charts
    _registerCharts: function()
    {
        // new chart for memory history
        var memoryChart = new PortalChart;
        memoryChart.elementId = 'memory-chart';
        memoryChart.type = 'line';
        memoryChart.dataFormat = 'number';
        memoryChart.columns = [];
        this.memoryChart = memoryChart;
    
        // new chart for compute history
        var computeChart = new PortalChart;
        computeChart.elementId = 'compute-chart';
        computeChart.type = 'line';
        computeChart.dataFormat = 'number';
        computeChart.columns = [];
        this.computeChart = computeChart;
        
        // build charts that might be used for the resource pool storages
        for(var i = 1; i <= this.maxCharts; i++){
            var newChart = $('.chart-container.clone-source').clone();
            $(newChart).attr('data-chart-number', i);
            $('.timeline-chart', newChart).attr('id', 'resoure-pool-chart-' + i);
            newChart.removeClass('clone-source');
            newChart.addClass('hidden');
            $('#resoure-pool-charts').append(newChart);
            
            var newChartObj = new PortalChart;
            newChartObj.elementId = $('.timeline-chart', newChart).attr('id');
            newChartObj.type = 'line';
            this['resourcePoolChart-' + i] = newChartObj;
        }
        
        // removing since we're done with it
        $('.chart-container.clone-source').remove();
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceResourcePoolController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceResourcePoolController._updateSelectedRange(this);
        });
        
        // download the csv file of the vms clicked
        $('.download-vms').on('click', function(e) {
            e.preventDefault();
            
            PortalMain.ServiceResourcePoolController._downloadVms();
        });
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // Gets usage-based specific information from the API
    _getResourcePoolOrder: function()
    {
        var resourcePoolOrderRequest = new PortalRequest;
        resourcePoolOrderRequest.makeRequest(
            '/resource-pools/get-resource-pool-order',
            {
                baseOrderId: this.baseOrderId
            },
            function(data) {
                PortalMain.ServiceResourcePoolController._populateResourcePoolCurrentStats(data);
            }
        );
    },
    
    // retrieves the timeline draas stats
    _getResourcePoolStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var resourcePoolStatsRequest = new PortalRequest;
        resourcePoolStatsRequest.makeRequest(
            '/resource-pools/get-resource-pool-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceResourcePoolController._populateResourcePoolStats(data, startDate, endDate);
            }
        );
    },
    
    // get the orders from the api
    _getVms: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceResourcePoolController.pagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceResourcePoolController.baseOrderId;
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServiceResourcePoolController.lastSubmittedData)) {
            PortalMain.ServiceResourcePoolController.pagination.showPagination();
            return;
        }
        PortalMain.ServiceResourcePoolController.lastSubmittedData = submissionData;
        
        // make the request
        var vmsRequest = new PortalRequest;
        vmsRequest.pageNumber = submissionData.page;
        vmsRequest.makeRequest(
            '/resource-pools/get-resource-pool-vms',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServiceResourcePoolController.pagination.updatePagination(data);
                PortalMain.ServiceResourcePoolController.pagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.ServiceResourcePoolController.pagination.lastEvent;
                
                // fill the invoice chart data
                PortalMain.ServiceResourcePoolController._populateVmsTable(data, lastEvent);
            }
        );
    },
    
    // populate the resource pool stats
    _populateResourcePoolCurrentStats: function(stats)
    {
        // show the consumption based resource pool tooltip if needed
        if (!stats.memory_bytes_limit && !stats.cpu_hz_limit) {
            $('#resource-pool-stats .hover-popup').addClass('hidden');
            $('#resource-pool-stats #consumption-based-tooltip').removeClass('hidden');
        }
        
        // the number of progress circles to be built
        var progressCount = 2 + stats.vdc_storage_profiles.length;
        
        // set the box columns class
        var columnCount = 3;
        if ([1,2,4].indexOf(progressCount) != -1){
            columnCount = 2;
        }
        $('#resource-pool-stats .box-columns').addClass('box-columns-' + columnCount);
        
        // set the memory
        this._populateCurrentStat(
            'Memory', 
            stats.memory_bytes_used, 
            stats.memory_bytes_limit, 
            'bytes',
            1024
        );
        
        // set the compute
        this._populateCurrentStat(
            'Compute', 
            stats.cpu_hz_used, 
            stats.cpu_hz_limit, 
            'hertz',
            1000
        );
        
        // set the storage profiles
        for (var i in stats.vdc_storage_profiles) {
            var profile = stats.vdc_storage_profiles[i];
            
            this._populateCurrentStat(
                profile.name, 
                profile.bytes_used, 
                profile.bytes_limit, 
                'bytes',
                1024
            );
        }
        
        // add spacer divs
        if (columnCount != 2) {
            var maxCells = Math.ceil(progressCount / 3) * 3;
            var spacerCount = maxCells - progressCount;
            for (i = 1; i <= spacerCount; i++) {
                $('#resource-pool-stats div.box-columns').append('<div></div>');
            }
        }
    },
    
    // determine if the meter or progress circle should be shown
    _populateCurrentStat: function(title, used, limit, unit, power)
    {
        if (limit <= 0) {
            this._populateMeter(title, used, limit, unit, power);
        } else {
            this._populateProgressCircle(title, used, limit, unit, power);
        }
    },
    
    // create a meter
    _populateMeter: function (title, used, limit, unit, power)
    {
        var meter = $('#resource-pool-stats .clone-source').clone();
        meter.removeClass('clone-source');
        
        // remove the progress circle and small line
        $('.progress-circle', meter).remove();
        $('h4 + span', meter).remove();
        
        $('h4', meter).html(title);
        
        // populate the meter
        if (unit == 'bytes') {
            var minUnit = 'GB';
        } else if (unit == 'hertz') {
            var minUnit = 'GHz';
        }
        var usedUnit = PortalHelper.formatBytes(used, minUnit, null, unit, power);
        $('.meter .row span:nth-child(1)', meter).text(usedUnit[0]);
        $('.meter .row span:nth-child(2)', meter).text(usedUnit[1]);
        
        $('#resource-pool-stats div.box-columns').append(meter);
        
    },
    
    // create a progress circle
    _populateProgressCircle: function(title, used, limit, unit, power)
    {
        var progress = $('#resource-pool-stats .clone-source').clone();
        progress.removeClass('clone-source');
        
        // remove the meter section
        $('.meter', progress).remove();
        
        $('h4', progress).html(title);
        
        var percent = parseInt(used / limit * 100) + '%';
        $('.amount span', progress).html(percent);
        
        var roundedPercent = parseInt(used / limit * 100);
        roundedPercent = Math.round(roundedPercent / 5) * 5;
        $('.progress-circle', progress).attr('data-percent', roundedPercent);
        
        if (unit == 'bytes') {
            var minUnit = 'GB';
        } else if (unit == 'hertz') {
            var minUnit = 'GHz';
        }
        var usedUnit = PortalHelper.formatBytes(used, minUnit, null, unit, power);
        var limitUnit = PortalHelper.formatBytes(limit, minUnit, null, unit, power);
        var split = usedUnit.join('') + ' / ' + limitUnit.join('');
        $('h4 + span', progress).html(split);
        
        $('#resource-pool-stats div.box-columns').append(progress);
    },
    
    // populate the orders table
    _populateVmsTable: function(vmsData, lastPaginationEvent)
    {    
        var vms = vmsData.data;
        
        // clear the old vms
        if (lastPaginationEvent != 'more') {
            $('#vms-table tbody tr:not(.clone-source)').remove();
        }
        
        // add the new vms to the DOM
        for (var i in vms) {
            var vm = vms[i];
            var newEntry = $('#vms-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the name
            $('.name', newEntry).html(vm.name);
            
            // apply the memory bytes
            var memory = PortalHelper.formatBytes(vm.memory_bytes, 'GB', null, null, 1024);
            $('.memory', newEntry).html(memory);
            
            // apply the number of cpus
            $('.number-of-cpus', newEntry).html(vm.number_of_cpus);
            
            // add to to the table
            $('#vms-table tbody').append(newEntry);
        }
        
    },
    
    // populate the usage charts
    _populateResourcePoolStats: function(data, startDate, endDate)
    {
        $('.chart-container').addClass('hidden');
        $('.chart-container h1').removeClass('hidden');
        
        for (var i in data) {
            var chartData = data[i];
            var chart = this._getChartByName(chartData.name);
            
            // unhide the container
            var chartElement = $('#' + chart.elementId).parents('.chart-container');
            chartElement.removeClass('hidden');
            
            // populate the name
            $('h2', chartElement).html(chartData.name);
            
            chart.dataFormat = chartData.unitOfMeasure;
            chart.minDate = startDate;
            chart.maxDate = endDate;
            
            // compute uses a power of 1000, as where the other charts use 1024
            if (chartData.unitOfMeasure == 'hertz') {
                chart.dataPower = 1000;
            } else {
                chart.dataPower = 1024;
            }
            
            // set the columns
            chart.columns = [];
            for(var i in chartData.chartData[0]) {
                var currentField = chartData.chartData[0][i];
                if(currentField == 'Time') {
                    chart.columns[i] = ['date', currentField];
                } else {
                    chart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#' + chart.elementId).text("No data available for this period.");
            } else {
                chart.data = chartData.chartData;
                chart.draw();
            }
                    
            PortalHelper.loadingOverlay('#' + chart.elementId, false);
        }
        
        // hide the first container header, and copy it to the dropdown header
        $('.chart-container:nth-of-type(2) h2').addClass('hidden');
        var heading = $('.chart-container:nth-of-type(2) h2').html();
        $('.selection-heading #title').html(heading);
    },
    
    // returns a chart object that is associated with the storage profile name.
    _getChartByName: function(chartName)
    {
        var currentChart = false;
        
        chartName = chartName.toLowerCase().split(' ').join('-');
        
        // finding chart based on name
        $('.chart-container').each(function(){
            if(this.dataset.chartName == chartName) {
                currentChart = $(this).attr('data-chart-number');
            }
        });
        
        // if no chart exists with that name, find the first one without a name
        if(currentChart == false) {
            $('.chart-container').each(function(){
                if(this.dataset.chartName == undefined){
                    this.dataset.chartName = chartName;
                    currentChart = $(this).attr('data-chart-number');
                    return false;
                }
            })
        }
        
        return this['resourcePoolChart-' + currentChart];
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('.timeline-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getResourcePoolStats(startDate, endDate);
        
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
    // download the vms csv from the api
    _downloadVms: function()
    {
        PortalHelper.loadingOverlay('#vms-pagination', true);
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceResourcePoolController.pagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceResourcePoolController.baseOrderId;
        
        // make the request
        var downloadVmsRequest = new PortalRequest;
        downloadVmsRequest.pageNumber = submissionData.page;
        downloadVmsRequest.isBinary = true;
        downloadVmsRequest.makeRequest(
            '/resource-pools/download-resource-pool-vms',
            submissionData,
            function(data) {
                PortalHelper.loadingOverlay('#vms-pagination', false);
                
                // build the file name
                var fileName = $('.order-number .value').html();
                fileName += '-VMs';
                fileName = fileName.replace(/ /g,'-');
                fileName += '.csv';
                
                PortalHelper.downloadFile(data, fileName);
            },
            function() {
                PortalHelper.loadingOverlay('#vms-pagination', false);
                PortalHelper.openErrorPopup(
                    'Download Error',
                    'There was an error downloading this file. This may be because there are no VMs to download. Change your search settings, and try again.'
                );
            }
        );
    },
    
}